import { ConditionValueInputComponent } from 'Automations/nodeDefinitions/conditions'
import { NumberInputField } from 'Automations/nodeDefinitions/components'
import { formatCurrencyInput } from '@sequencehq/utils'
import { clampNumeric } from './clampNumeric'

/**
 * Plain currency-style amount input — no unit selector. For operators that
 * always interpret their value in a fixed unit (or where the unit is irrelevant
 * to runtime evaluation).
 */
export const AmountInput: ConditionValueInputComponent = ({
  'data-testid': dataTestId,
  value,
  onChange,
  validationErrors
}) => (
  <NumberInputField
    data-testid={dataTestId ? `${dataTestId}.value` : undefined}
    value={value}
    placeholder="0.00"
    textAlign="right"
    onChange={e => onChange({ value: e.target.value })}
    onBlur={() => {
      const clamped = clampNumeric(value, { min: 0 })
      const formatted = formatCurrencyInput(String(clamped), 'currency')
      onChange({ value: formatted })
    }}
    validationErrors={validationErrors}
  />
)
